// import imagesLoaded from "imagesloaded"
// import Masonry from "masonry-layout"
// import InfiniteScroll from "infinite-scroll"
import { q, qq } from "../../helper/q"
import { masonryInit } from "./msnry"
import { Ias } from "./ias"
import { sliderInit } from "./slider"
import { stickyTopInit } from "./top"

export const newsInit = () => {
  const containers = q(".articlesGroup")
  if (containers) {
    const msnr = masonryInit()
    const ias = new Ias(containers, msnr)
    ias.init()
  }

  sliderInit()
  stickyTopInit()
}
